import {colors} from '../../../foundation/colors';

export const MuiButton = {
  root: {
    borderRadius: '3px',
    padding: '4px 12px',
    minWidth: '56px',
    '&:hover': {
      backgroundColor: colors.blackAlpha[50],
    },
    '&:focus': {
      backgroundColor: colors.blackAlpha[50],
    },
    '&:disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  },
  contained: {
    '&.MuiButton-sizeSmall': {
      padding: '1px 8px',
    },
    '&.MuiButton-sizeLarge': {
      padding: '7px 22px',
    },
    '&.MuiButton-colorPrimary:focus': {
      backgroundColor: '#004D96',
    },
  },
  outlined: {
    padding: '3px 11px',
    border: `1px solid ${colors.blackAlpha[600]}`,
    '&.MuiButton-colorPrimary': {
      '&:hover': {
        border: '1px solid rgba(46, 120, 199, 0.5)',
      },
      '&:focus': {
        backgroundColor: 'rgba(46, 120, 199, 0.04)',
        border: '1px solid rgba(46, 120, 199, 0.5)',
      },
    },
    '&.MuiButton-sizeSmall': {
      padding: '0 7px',
    },
    '&.MuiButton-sizeLarge': {
      padding: '6px 20px',
    },
    '&.MuiButton-colorSecondary': {
      border: '1px solid rgba(117, 117, 117, 0.5)',
      '&:hover': {
        border: `1px solid ${colors.gray[500]}`,
        backgroundColor: colors.blackAlpha[50],
      },
      '&:focus': {
        border: `1px solid ${colors.gray[500]}`,
        backgroundColor: colors.blackAlpha[50],
      },
      '&.Mui-disabled': {
        border: `1px solid ${colors.gray[400]}`,
      },
    },
  },
  text: {
    padding: '3px 11px',
    '&.MuiButton-colorPrimary': {
      color: '#2E78C7',
      '&:hover': {
        backgroundColor: 'rgba(46, 120, 199, 0.04)',
      },
      '&:focus': {
        backgroundColor: 'rgba(46, 120, 199, 0.04)',
      },
    },
    '&.MuiButton-sizeSmall': {
      padding: '1px 8px',
    },
    '&.MuiButton-sizeLarge': {
      padding: '7px 22px',
    },
  },
  sizeSmall: {
    '& .MuiButton-icon > *:first-child': {
      fontSize: '1.12rem',
    },
  },
  endIcon: {
    marginLeft: '4px',
  },
  startIcon: {
    marginRight: '4px',
  },
};
